import React from 'react';

export default {
  email: {
    rule: value => /@/.test(value),
    hint: value => <span className="input-subtext">Invalid email</span>
  },
  password: {
    rule: value => 24 >= value.length && value.length >= 5,
    hint: value => <span className="input-subtext">Password must have between 5 and 24 chars</span>
  },
  required: {
    rule: value => value.trim().length,
    hint: value => <span className="input-subtext">Required</span>
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/validators.js
 **/